import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircle, Home, FileText } from 'lucide-react';
import Header from '../components/Header';
import Sidebar from '../components/Sidebar';

const PaymentSuccess = () => {
  const navigate = useNavigate();

  return (
    <div className="dashboard-container">
      <Header />
      <div className="dashboard-wrapper">
        <Sidebar activeItem="application" />
        <div className="flex-grow-1 dashboard-content">
          <div className="payment-success-container">
            <div className="payment-success-card">
              <div className="text-center mb-4">
                <CheckCircle size={64} className="text-success mb-3" />
                <h2 className="text-success mb-3">Payment Successful!</h2>
                <p className="text-muted mb-4">
                  Your payment has been processed successfully and your swimming training application has been submitted.
                </p>
              </div>

              <div className="success-info">
                <h5>What's Next?</h5>
                <ul className="next-steps">
                  <li>You will receive a confirmation email with your application details</li>
                  <li>Our team will review your application within 2-3 business days</li>
                  <li>You can check your application status anytime from the dashboard</li>
                  <li>Training schedule will be communicated via email and SMS</li>
                </ul>
              </div>

              <div className="action-buttons">
                <button 
                  className="enhanced-btn btn-primary"
                  onClick={() => navigate('/dashboard')}
                >
                  <Home size={20} />
                  <span>Go to Dashboard</span>
                </button>
                <button 
                  className="enhanced-btn btn-secondary"
                  onClick={() => navigate('/application')}
                >
                  <FileText size={20} />
                  <span>New Application</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccess;
